import { Section, SectionHeading } from "@/components/ui";

/** "From curiosity to career": four stages from sampling the work to specialising. */
export function IndustryJourney({ journey }) {
  return (
    <Section labelledBy="industry-journey-title" testId="industry-journey">
      <SectionHeading id="industry-journey-title" title={journey.title} intro={journey.lead} />

      <ol className="mt-8 grid gap-4 sm:mt-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5" data-testid="industry-journey-steps">
        {journey.steps.map((step, i) => (
          <li key={step.title}>
            <article className="flex h-full flex-col rounded-3xl border border-brand-200 bg-white p-5 sm:p-6">
              <span className="flex items-center gap-3">
                <span
                  aria-hidden="true"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-500 font-heading text-base font-bold text-white"
                >
                  {i + 1}
                </span>
                <small className="rounded-full bg-brand-50 px-3 py-1 text-xs font-bold text-brand-700 sm:text-sm">{step.age}</small>
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold leading-tight sm:text-2xl">{step.title}</h3>
              <p className="mt-2 text-base text-ink/70">{step.text}</p>
            </article>
          </li>
        ))}
      </ol>
    </Section>
  );
}
